import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "bg-backgroundColor pt-14" }
const _hoisted_3 = {
  key: 0,
  class: "w-389 px-5"
}
const _hoisted_4 = { class: "flex flex-nowrap items-center justify-start mb-10 ps-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-none rounded-full w-24 h-24 bg-gray overflow-hidden me-5 border-4 border-yellow-500" }, null, -1)
const _hoisted_6 = { class: "text-xl text-darkText" }
const _hoisted_7 = { class: "text-start ps-7 mb-8" }
const _hoisted_8 = { class: "text-start mb-6 text-lg text-darkText font-bold" }
const _hoisted_9 = {
  key: 0,
  class: "flex justify-start mb-6 text-base"
}
const _hoisted_10 = { class: "text-start text-darkText font-bold w-28" }
const _hoisted_11 = { class: "text-start text-textColor font-normal ms-5" }
const _hoisted_12 = { class: "flex justify-start mb-6 text-base" }
const _hoisted_13 = { class: "text-start text-darkText font-bold w-28" }
const _hoisted_14 = { class: "text-start text-textColor font-normal ms-5" }
const _hoisted_15 = { class: "flex justify-start mb-6 text-base" }
const _hoisted_16 = { class: "text-start text-darkText font-bold w-28" }
const _hoisted_17 = { class: "text-start text-textColor font-normal ms-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = { class: "text-start ps-7 my-8" }
const _hoisted_20 = { class: "text-start mb-6 text-lg text-darkText font-bold" }
const _hoisted_21 = { class: "flex justify-start text-base" }
const _hoisted_22 = { class: "text-start text-darkText font-bold w-28" }
const _hoisted_23 = { class: "text-start text-textColor font-normal ms-5" }
const _hoisted_24 = {
  key: 0,
  class: "flex justify-start text-base mt-5"
}
const _hoisted_25 = { class: "text-start text-darkText font-bold w-28" }
const _hoisted_26 = { class: "text-start text-textColor font-normal ms-5" }
const _hoisted_27 = { class: "flex justify-start text-base mt-5 items-center" }
const _hoisted_28 = { class: "flex items-center gap-1" }
const _hoisted_29 = { class: "text-start text-darkText font-bold" }
const _hoisted_30 = { class: "mx-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_32 = { class: "text-start ps-7 my-8" }
const _hoisted_33 = { class: "text-start mb-6 text-lg text-darkText font-bold" }
const _hoisted_34 = { class: "flex justify-start text-base" }
const _hoisted_35 = { class: "text-start text-darkText font-bold w-38" }
const _hoisted_36 = { class: "flex justify-start text-base mt-5" }
const _hoisted_37 = { class: "text-start text-darkText font-bold w-38" }
const _hoisted_38 = { class: "flex justify-start text-base mt-5" }
const _hoisted_39 = { class: "text-start text-darkText font-bold w-38 pt-1" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_41 = { class: "text-start ps-7 my-8" }
const _hoisted_42 = { class: "text-start mb-6 text-lg text-darkText font-bold" }
const _hoisted_43 = { class: "flex justify-start mb-6 text-base" }
const _hoisted_44 = { class: "text-start text-darkText font-bold w-28 me-5" }
const _hoisted_45 = { class: "text-start text-textColor font-normal" }
const _hoisted_46 = {
  key: 0,
  class: "text-start mb-6 text-lg text-darkText font-bold"
}
const _hoisted_47 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_49 = { class: "text-start ps-7 my-8" }
const _hoisted_50 = { class: "text-start mb-6 text-lg text-darkText font-bold" }
const _hoisted_51 = { class: "flex justify-start mb-6 text-base" }
const _hoisted_52 = { class: "text-start text-darkText font-bold w-28 me-5" }
const _hoisted_53 = {
  key: 1,
  class: "text-start font-normal"
}
const _hoisted_54 = {
  key: 0,
  class: "flex justify-start mb-6 text-base"
}
const _hoisted_55 = { class: "text-start text-darkText font-bold w-28 me-5" }
const _hoisted_56 = { class: "text-start text-textColor font-normal" }
const _hoisted_57 = {
  key: 1,
  class: "flex justify-start text-base"
}
const _hoisted_58 = { class: "text-start text-darkText font-bold w-28 me-5" }
const _hoisted_59 = { class: "text-start text-textColor font-normal" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-end" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_62 = { class: "text-start ps-7 my-8" }
const _hoisted_63 = { class: "text-start mb-6 text-lg text-darkText font-bold" }
const _hoisted_64 = {
  key: 0,
  class: "flex justify-start mb-6 text-base"
}
const _hoisted_65 = { class: "text-start text-darkText font-bold w-28 me-5" }
const _hoisted_66 = { class: "text-start text-textColor font-normal" }
const _hoisted_67 = {
  key: 2,
  class: "text-center"
}
const _hoisted_68 = { class: "w-full" }
const _hoisted_69 = { class: "rounded-0.5xl bg-white mx-10 mt-16" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_71 = { class: "p-6" }
const _hoisted_72 = { class: "form-group mt-4" }
const _hoisted_73 = { class: "floating-label" }
const _hoisted_74 = { class: "flex justify-end mt-6" }
const _hoisted_75 = { class: "p-6" }
const _hoisted_76 = { class: "form-group mt-4" }
const _hoisted_77 = { class: "floating-label" }
const _hoisted_78 = { class: "form-group mt-4" }
const _hoisted_79 = { class: "floating-label" }
const _hoisted_80 = { class: "form-group mt-4" }
const _hoisted_81 = { class: "floating-label" }
const _hoisted_82 = { class: "form-group mt-4" }
const _hoisted_83 = { class: "floating-label" }
const _hoisted_84 = { class: "form-group mt-4" }
const _hoisted_85 = { class: "floating-label" }
const _hoisted_86 = { class: "form-group mt-4" }
const _hoisted_87 = { class: "floating-label" }
const _hoisted_88 = { class: "flex justify-end mt-6" }
const _hoisted_89 = { class: "p-6" }
const _hoisted_90 = { class: "form-group mt-4" }
const _hoisted_91 = { class: "floating-label" }
const _hoisted_92 = { class: "flex justify-end mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_DriverBalance = _resolveComponent("DriverBalance")!
  const _component_DynamicTableErpSyncStatus = _resolveComponent("DynamicTableErpSyncStatus")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_DriverMap = _resolveComponent("DriverMap")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BaseModal = _resolveComponent("BaseModal")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.driver)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_PageTitle, {
                  class: "ps-1",
                  title: "drivers.profileTitle"
                }),
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.createDriverFullName(_ctx.driver.driverInfo)), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('drivers.personalInfo')), 1),
                  (_ctx.driver.driverInfo.userPhone)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('drivers.phone')), 1),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.driver.driverInfo.userPhone), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('drivers.idNumber')), 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.driver.id), 1)
                  ]),
                  _createElementVNode("p", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('drivers.address')), 1),
                    _createElementVNode("span", _hoisted_17, [
                      _createTextVNode(_toDisplayString(_ctx.driver.driverAddress.addressDistrict ? _ctx.driver.driverAddress.addressDistrict + ',' : null) + " " + _toDisplayString(_ctx.driver.driverAddress.addressBuilding ? _ctx.driver.driverAddress.addressBuilding + ',' : null) + " " + _toDisplayString(_ctx.driver.driverAddress.addressFlat ? _ctx.driver.driverAddress.addressFlat + ',' : null) + " " + _toDisplayString(_ctx.driver.driverAddress.addressFloor ? _ctx.driver.driverAddress.addressFloor + ',' : null) + " " + _toDisplayString(_ctx.driver.driverAddress.addressNearestLandmark ? _ctx.driver.driverAddress.addressNearestLandmark + ',' : null) + " " + _toDisplayString(_ctx.driver.driverAddress.addressNeighborhood ? _ctx.driver.driverAddress.addressNeighborhood + ',' : null) + " ", 1),
                      _createVNode(_component_BaseIcon, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddressModal = true)),
                        class: "w-4 ms-2 cursor-pointer",
                        name: "pen"
                      })
                    ])
                  ])
                ]),
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('drivers.settingsInfo')), 1),
                  _createElementVNode("p", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('drivers.boxNumber')), 1),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.driver.boxNumber), 1),
                    _createVNode(_component_BaseIcon, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showBoxNumberModal = true)),
                      class: "w-4 ms-2 cursor-pointer",
                      name: "pen"
                    })
                  ]),
                  (_ctx.isSuperAdmin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('drivers.trackingId')), 1),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.driver.trackingId), 1),
                        _createVNode(_component_BaseIcon, {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTrackingIdModal = true)),
                          class: "w-4 ms-2 cursor-pointer",
                          name: "pen"
                        }),
                        (_ctx.driver.trackingId)
                          ? (_openBlock(), _createBlock(_component_BaseIcon, {
                              key: 0,
                              onClick: _ctx.deleteTrackingId,
                              class: "w-4 ms-2 cursor-pointer",
                              name: "trash"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_Popper, {
                        arrow: "",
                        hover: "",
                        placement: "auto"
                      }, {
                        content: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('drivers.checkUnpaidOrdersFromThePreviousDay')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_BaseIcon, {
                            name: "info",
                            "class-names": "w-4 h-4"
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('drivers.checkUnpaidOrders')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_Toggle, {
                        modelValue: _ctx.checkUnpaidOrdersFromThePreviousDay,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkUnpaidOrdersFromThePreviousDay) = $event)),
                          _ctx.onUpdateCheckUnpaidOrders
                        ]
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ])
                ]),
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t('drivers.financialInfo')), 1),
                  _createElementVNode("p", _hoisted_34, [
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('drivers.balance')), 1),
                    _createVNode(_component_DriverBalance, {
                      balance: _ctx.driver?.balance ?? 0
                    }, null, 8, ["balance"])
                  ]),
                  _createElementVNode("p", _hoisted_36, [
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('drivers.syncStatus')), 1),
                    _createVNode(_component_DynamicTableErpSyncStatus, { data: _ctx.driver }, null, 8, ["data"])
                  ]),
                  _createElementVNode("p", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('drivers.manualSync')), 1),
                    _createElementVNode("button", {
                      class: "primary py-1.5 px-4",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.reTryErpSync && _ctx.reTryErpSync(...args)))
                    }, _toDisplayString(_ctx.$t('buttons.retryErpsSync')), 1)
                  ])
                ]),
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t('drivers.workShift')), 1),
                  _createElementVNode("p", _hoisted_43, [
                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('drivers.hours')), 1),
                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.driver.shift.shiftStart) + " - " + _toDisplayString(_ctx.driver.shift.shiftEnd), 1)
                  ]),
                  (_ctx.isSuperAdmin)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.$t('drivers.status')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.isSuperAdmin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createVNode(_component_Multiselect, {
                          canClear: false,
                          onSelect: _cache[5] || (_cache[5] = ($event: any) => {_ctx.showUpdateStatusConfirmation = true;}),
                          modelValue: _ctx.status,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.status) = $event)),
                          options: _ctx.statuses,
                          label: "value",
                          valueProp: "id",
                          object: "true",
                          noOptionsText: _ctx.$t('validation.noItemsToShow'),
                          placeholder: _ctx.$t('placeholders.driverStatus')
                        }, null, 8, ["modelValue", "options", "noOptionsText", "placeholder"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t('drivers.documents')), 1),
                  _createElementVNode("p", _hoisted_51, [
                    _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t('drivers.license')), 1),
                    (_ctx.driver.license)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadFile(_ctx.driver.license))),
                          class: "text-start text-blue-500 font-normal cursor-pointer"
                        }, _toDisplayString(_ctx.$t('drivers.showFile')), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.driver.license)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.$t('drivers.notUploaded')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.driver.vehicleInfo)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_54, [
                        _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('drivers.id')), 1),
                        _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.driver.vehicleInfo.licenseNo), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.driver.vehicleInfo)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_57, [
                        _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t('drivers.vehicle')), 1),
                        _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.driver.vehicleInfo.name) + " " + _toDisplayString(_ctx.driver.vehicleInfo.model), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_60,
                _hoisted_61,
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.$t('drivers.lastLocation')), 1),
                  (_ctx.driverLastLocation)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_64, [
                        _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t('drivers.lastLocationDate')), 1),
                        _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.moment(_ctx.driverLastLocation.timestamp).format('DD/MM/YYYY hh:mm A')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.driverLastLocation)
                    ? (_openBlock(), _createBlock(_component_DriverMap, {
                        key: 1,
                        driver: {
                ..._ctx.driver,
                lastLocation: {
                  latitude: _ctx.driverLastLocation.latitude,
                  longitude: _ctx.driverLastLocation.longitude,
                }
              },
                        style: {"height":"200px"}
                      }, null, 8, ["driver"]))
                    : _createCommentVNode("", true),
                  (_ctx.driverLastLocation === null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_ctx.$t('drivers.locationInfoNotFound')), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createVNode(_component_Tab, {
              "tab-items": _ctx.tableItems,
              onTabChanged: _ctx.onChangeTab
            }, null, 8, ["tab-items", "onTabChanged"]),
            _createVNode(_component_router_view)
          ])
        ])
      ])
    ]),
    _hoisted_70,
    (_ctx.showBoxNumberModal)
      ? (_openBlock(), _createBlock(_component_BaseModal, {
          key: 0,
          title: _ctx.$t('drivers.changeBoxNumber'),
          width: '488',
          onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showBoxNumberModal = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: " ",
                  class: "h-42 form-control",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.boxNumberData) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.boxNumberData]
                ]),
                _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t('drivers.boxNumber')), 1)
              ]),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showBoxNumberModal = false)),
                  class: "tertiary px-6 py-3 me-2"
                }, _toDisplayString(_ctx.$t('buttons.close')), 1),
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateBoxNumber())),
                  class: "primary px-6 py-3"
                }, _toDisplayString(_ctx.$t('buttons.saveChanges')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.showAddressModal)
      ? (_openBlock(), _createBlock(_component_BaseModal, {
          key: 1,
          title: _ctx.$t('drivers.changeAddress'),
          width: '488',
          onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showAddressModal = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: " ",
                  class: "h-42 form-control",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.district) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.district]
                ]),
                _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t('drivers.district')), 1)
              ]),
              _createElementVNode("div", _hoisted_78, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: " ",
                  class: "h-42 form-control",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.building) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.building]
                ]),
                _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t('drivers.building')), 1)
              ]),
              _createElementVNode("div", _hoisted_80, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: " ",
                  class: "h-42 form-control",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.flat) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.flat]
                ]),
                _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.$t('drivers.flat')), 1)
              ]),
              _createElementVNode("div", _hoisted_82, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: " ",
                  class: "h-42 form-control",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.floor) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.floor]
                ]),
                _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t('drivers.floor')), 1)
              ]),
              _createElementVNode("div", _hoisted_84, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: " ",
                  class: "h-42 form-control",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.landmark) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.landmark]
                ]),
                _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.$t('drivers.landmark')), 1)
              ]),
              _createElementVNode("div", _hoisted_86, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: " ",
                  class: "h-42 form-control",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.neighborhood) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.neighborhood]
                ]),
                _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t('drivers.neighborhood')), 1)
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("button", {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showAddressModal = false)),
                  class: "tertiary px-6 py-3 me-2"
                }, _toDisplayString(_ctx.$t('buttons.close')), 1),
                _createElementVNode("button", {
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.updateAddress())),
                  class: "primary px-6 py-3"
                }, _toDisplayString(_ctx.$t('buttons.saveChanges')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.showTrackingIdModal)
      ? (_openBlock(), _createBlock(_component_BaseModal, {
          key: 2,
          title: _ctx.$t('drivers.changeTrackingId'),
          width: '488',
          onClose: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showTrackingIdModal = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  placeholder: " ",
                  class: "h-42 form-control",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.trackingIdData) = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.trackingIdData,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t('drivers.trackingId')), 1)
              ]),
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("button", {
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showTrackingIdModal = false)),
                  class: "tertiary px-6 py-3 me-2"
                }, _toDisplayString(_ctx.$t('buttons.close')), 1),
                _createElementVNode("button", {
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.updateTrackingId())),
                  class: "primary px-6 py-3"
                }, _toDisplayString(_ctx.$t('buttons.saveChanges')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.showUpdateStatusConfirmation)
      ? (_openBlock(), _createBlock(_component_ConfirmationModal, {
          key: 3,
          header: _ctx.$t('drivers.statusConfirmation.header'),
          hasIcon: false,
          title: _ctx.$t('drivers.statusConfirmation.title'),
          cancelText: _ctx.$t('buttons.no'),
          confirmText: _ctx.$t('buttons.yesUpdate'),
          onConfirm: _cache[25] || (_cache[25] = ($event: any) => {_ctx.updateDriverStatus();_ctx.showUpdateStatusConfirmation = false}),
          onCancel: _cache[26] || (_cache[26] = ($event: any) => {_ctx.showUpdateStatusConfirmation = false;_ctx.showUpdateStatusModal = false})
        }, null, 8, ["header", "title", "cancelText", "confirmText"]))
      : _createCommentVNode("", true)
  ], 64))
}